import _map from 'lodash/map';
import _keyBy from 'lodash/keyBy';
import _zipObject from 'lodash/zipObject';

export const normalizeMetadata = (choices) => {
  const metaDataAndChoiceId = _map(
    choices, ({ id, metaDataItems }) => {
      const names = _map(metaDataItems, 'name');
      const values = _map(metaDataItems, 'value');
      return {
        choiceId: id,
        metadata: _zipObject(names, values)
      };
    }
  );
  return _keyBy(metaDataAndChoiceId, 'choiceId');
};
